import posthog from 'posthog-js';
import { getConsentCategories } from '../assets/js/consent.ts';

export function usePostHog() {
  if (!window.posthog) {
    const ph_instance = posthog.init('phc_BIqfDVChynpFnMZM0hKMEMzlgWl4j4tF6AblOIAWzlP', {
      cookieless_mode: 'on_reject',
      api_host: 'https://e.rackmanage.io',
      flags_api_host: 'https://features.rackmanage.io',
      ui_host: 'https://eu.posthog.com',
      person_profiles: 'identified_only',
      defaults: '2025-05-24',
    });

    const consentCategories = getConsentCategories();
    if (consentCategories.includes('performance')) {
      ph_instance.opt_in_capturing();
    } else {
      ph_instance.opt_out_capturing();
    }

    window.posthog = ph_instance;
  }

  return { posthog };
}
